function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M341.334 85.33H0v341.332h512V85.33z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 85.333h170.663V426.67H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M170.663 85.333h170.663V426.67H170.663z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M208 255.996c0 26.509 21.491 48 48 48s48-21.491 48-48v-16h-96v16z",
  fill: "#6da544"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M320 223.996h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16H208c0 8.836 7.164 16 16 16 0 8.836 7.164 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.836 0 16.533-7.163 16.533-16z",
  fill: "#ff9811"
});

const SvgMexico = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMexico, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mexico.0a830f06.svg";
export { ForwardRef as ReactComponent };